<template>
  <div v-if="assets && assets.length" class="asset-gallery">
    <tiny-slider
      class="asset-gallery__images" 
      v-bind="imageSliderOptions"
      @transitionStart="restartVideo"
    >
      <div v-for="asset in assets" :key="asset.assetId" class="asset-wrapper">
        <video
          v-if="asset.asset.type === 'video'"
          :id="`video${asset.assetId}`"
          class="asset-gallery__video"
          :src="`${$store.state.assetsPath + asset.asset.path}`"
          autoplay
          muted
          loop 
        ></video>
        <img
          v-if="asset.asset.type === 'image'"
          class="asset-gallery__image"
          :src="$store.state.assetsPath + asset.asset.path"
        />
      </div>
    </tiny-slider>
    <div v-show="showNav" class="asset-gallery__thumbnails">
      <div class="asset-gallery__thumbnail" v-for="asset in assets" :key="'gallery' + asset.assetId">
        <img :src="$store.state.assetsPath + asset.asset.thumbPath">
      </div>
    </div>
  </div>
</template>
<script>
import TinySlider from 'vue-tiny-slider'
import VideoPlayer from '@/components/VideoPlayer'

export default {
  components: { TinySlider },
  props: [ 'contain-images', 'assets', 'autoplay', 'show-nav', 'VideoPlayer' ],
  data () {
    return {
      imageSliderOptions: {
        mode: "gallery",
        autoplay: false,
        autoplayTimeout: 4500,
        autoplayButton: false,
        autoplayButtonOutput: false,
        mouseDrag: false,
        controls: false,
        loop: true,
        items: 1,
        gutter: 0,
        nav: true,
        navContainer: '.asset-gallery__thumbnails',
        navAsThumbnails: true,
        speed: 3000,
        animateIn: 'background--show',
        animateOut: 'background--hide',        
      },
    }
  },

  mounted () {
    const videos = document.querySelectorAll('video')
    if (videos.length > 0) {
      videos.forEach((video, i) => {
        if (i !== 0) {
          video.pause()
        }
      })
    }
  },

  methods: {
    restartVideo (e) {
      const assetId = this.assets[e.index].assetId
      const video = document.querySelector(`#video${assetId}`)

      if (video) {
        video.pause()
        video.currentTime = 0;
        video.load();
      }
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
.asset-gallery {
  left: 0;
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;

  &--nav {
    padding-bottom: 14rem;
  }  

  .tns-outer, .tns-inner {
    height: 100%;
  }

  &__images {
    height: 100%;
    width: 100%;
  }

  &__image {
    height: 100rem;
    width: 100%;
    object-fit: cover;
    pointer-events: none;
  }

  &__video {
    height: 100rem;
    width: 100%;
    object-fit: cover;
  }

  &__thumbnails {
    bottom: 0;
    position: absolute;
    text-align: center;
    width: 100%;
    z-index: 10;

    .tns-nav-active {
      border: 0.1rem solid $white;
      box-shadow: 0 0 1rem $white;
      margin: 2rem 2.7rem;
      transform: scale(1.2);
      transform-origin: 50% 100%;
    }
  }

  &__thumbnail {
    border: 0.1rem solid $white;
    border-radius: .5rem;
    box-shadow: $tag-box-shadow;
    display: inline-block;
    height: 10.5rem;
    margin: 2rem 1rem;
    overflow: hidden;
    position: relative;
    transform: scale(1);
    transform-origin: 50% 100%;
    transition: all 300ms ease-in-out;
    width: 16rem;

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
}
</style>